// src/config/planLimits.js
// ── Single source of truth for plan limits ────────────────────────────────────
// All enforcement points (web app, API, mobile) read from this file.
// To change a limit: update ONE number here. Nothing else.
//
// null = unlimited

export const PLAN_LIMITS = {
  starter: {
    users:    3,
    events:   5,
    crm:      false,
    meetings: false,
  },
  professional: {
    users:    10,
    events:   15,
    crm:      true,
    meetings: false,
  },
  enterprise: {
    users:    null,   // unlimited
    events:   null,   // unlimited
    crm:      true,
    meetings: true,
  },
};

/**
 * Returns the limits for a given tier.
 * Defaults to professional if tier is unrecognized.
 * @param {string} tier - "starter" | "professional" | "enterprise"
 * @returns {{ users: number|null, events: number|null, crm: boolean, meetings: boolean }}
 */
export function getLimits(tier) {
  return PLAN_LIMITS[tier] || PLAN_LIMITS.professional;
}

/**
 * Returns whether a given count is at or over the limit for a tier.
 * @param {string} tier
 * @param {"users"|"events"} resource
 * @param {number} currentCount
 * @returns {boolean}
 */
export function isAtLimit(tier, resource, currentCount) {
  const limit = getLimits(tier)[resource];
  if (limit === null) return false; // unlimited
  return currentCount >= limit;
}

/**
 * Returns whether a count is approaching the limit (80%+) but not yet at it.
 * @param {string} tier
 * @param {"users"|"events"} resource
 * @param {number} currentCount
 * @returns {boolean}
 */
export function isNearLimit(tier, resource, currentCount) {
  const limit = getLimits(tier)[resource];
  if (limit === null) return false;
  return currentCount / limit >= 0.8 && currentCount < limit;
}

/**
 * Returns a human-readable description of the next tier upgrade.
 * @param {string} currentTier
 * @returns {{ tier: string, label: string, price: string, users: string, events: string }}
 */
export function getUpgradeTier(currentTier) {
  if (currentTier === "starter") {
    return {
      tier:   "professional",
      label:  "Professional",
      price:  "$399/month",
      users:  "10 team members",
      events: "15 events per year",
    };
  }
  if (currentTier === "professional") {
    return {
      tier:   "enterprise",
      label:  "Enterprise",
      price:  "$899/month",
      users:  "Unlimited team members",
      events: "Unlimited events",
    };
  }
  return null; // already enterprise
}
